import { createAction } from 'redux-actions';

export const fetchAllApplications = createAction('FETCH_ALL_APPLICATIONS');
export const fetchAllApplicationsSuccess = createAction('FETCH_ALL_APPLICATIONS_SUCCESS');
export const fetchAllApplicationsFailure = createAction('FETCH_ALL_APPLICATIONS_FAILURE');

export const deleteApplications = createAction('DELETE_APPLICATIONS');
export const deleteApplicationsSuccess = createAction('DELETE_APPLICATIONS_SUCCESS');
export const deleteApplicationsFailure = createAction('DELETE_APPLICATIONS_FAILURE');
